import React from 'react';
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';


function App() {
  return (
    <>
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="2000.000000pt" height="2000.000000pt" viewBox="0 0 2000.000000 2000.000000"
 preserveAspectRatio="xMidYMid meet" className="nukeproof-icon">

<g transform="translate(0.000000,2000.000000) scale(0.100000,-0.100000)">
<path d="M7355 13818 c-213 -24 -521 -109 -716 -199 -397 -183 -687 -436 -829
-724 -76 -152 -103 -256 -104 -395 -1 -100 2 -121 22 -165 55 -120 164 -191
367 -238 l90 -21 3250 -6 c3105 -5 3253 -6 3310 -24 212 -64 372 -181 444
-325 39 -77 45 -123 27 -208 -69 -331 -352 -640 -781 -853 -212 -105 -330
-144 -540 -180 -115 -20 -164 -20 -3198 -20 -1806 0 -3152 -4 -3252 -10 -337
-19 -559 -69 -810 -182 -280 -128 -537 -333 -734 -588 -133 -171 -184 -311
-185 -505 -1 -112 1 -124 27 -177 71 -145 282 -272 508 -308 55 -8 1180 -10
4354 -8 4047 3 4285 4 4375 21 255 48 445 109 650 211 324 160 521 350 737
711 155 260 747 1251 1136 1905 93 157 197 332 232 390 34 58 158 267 275 465
117 198 239 405 272 460 128 217 167 326 168 467 0 203 -102 368 -282 453
-147 70 235 65 -4473 64 -2458 -1 -4294 -5 -4340 -11z"/>
<path d="M9907 8199 c-268 -31 -559 -138 -868 -320 -219 -128 -473 -346 -571
-486 -94 -137 -149 -311 -151 -479 l-2 -112 44 -87 c24 -47 65 -110 90 -138
25 -29 154 -171 286 -317 1049 -1156 1112 -1222 1217 -1276 137 -70 462 -104
708 -74 460 56 881 269 1167 591 78 87 204 276 245 366 81 180 90 408 20 527
-11 19 -63 83 -115 143 -208 238 -609 698 -920 1055 -180 208 -347 393 -370
413 -111 96 -274 172 -417 194 -74 12 -261 12 -363 0z"/>
</g>
</svg>


    </>
  );
}

export default App;
